(function () {
  'use strict';

  function initHeader(header) {
    var dropdowns = header.querySelectorAll('[data-kac-dropdown]');
    var closeTimers = new WeakMap();

    function closeAll(except) {
      dropdowns.forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }

    dropdowns.forEach(function (dropdown) {
      var summary = dropdown.querySelector(':scope > summary');

      dropdown.addEventListener('mouseenter', function () {
        clearTimeout(closeTimers.get(dropdown));
        closeAll(dropdown);
        dropdown.setAttribute('open', '');
      });

      dropdown.addEventListener('mouseleave', function () {
        var t = window.setTimeout(function () {
          dropdown.removeAttribute('open');
        }, 150);
        closeTimers.set(dropdown, t);
      });

      if (summary) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(closeTimers.get(dropdown));
          closeAll(dropdown);
          dropdown.setAttribute('open', '');
        });

        summary.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' || e.key === 'Esc') {
            dropdown.removeAttribute('open');
            summary.focus();
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeAll();
    });

    var mobile = header.querySelector('[data-kac-mobile]');
    var toggleBtn = header.querySelector('[data-kac-mobile-toggle]');
    var closeEls = header.querySelectorAll('[data-kac-mobile-close]');

    function openMobile() {
      if (!mobile) return;
      mobile.classList.add('is-open');
      mobile.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        mobile.classList.add('is-visible');
      });
    }

    function closeMobile() {
      if (!mobile) return;
      mobile.classList.remove('is-visible');
      mobile.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(function () {
        mobile.classList.remove('is-open');
      }, 200);
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', openMobile);
    }
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeMobile);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && mobile && mobile.classList.contains('is-open')) {
        closeMobile();
      }
    });

    initPredictiveSearch(header);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function initPredictiveSearch(header) {
    var form = header.querySelector('[data-kac-search-form]');
    if (!form) return;

    var input = form.querySelector('[data-kac-search-input]');
    var resultsEl = form.querySelector('[data-kac-search-results]');
    var baseUrl = form.getAttribute('data-predictive-search-url');
    if (!input || !resultsEl || !baseUrl) return;

    var debounceTimer = null;
    var controller = null;
    var activeIndex = -1;
    var currentItems = [];
    var lastQuery = '';

    function hideResults() {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      activeIndex = -1;
      currentItems = [];
      input.setAttribute('aria-expanded', 'false');
    }

    function showResults() {
      resultsEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function buildGroup(label, items, render) {
      if (!items || !items.length) return '';
      var html = '<div class="kac-header__search-group-label">' + escapeHtml(label) + '</div>';
      items.forEach(function (item) {
        html += render(item);
      });
      return html;
    }

    function renderResults(data, query) {
      var results = (data && data.resources && data.resources.results) || {};
      var pages = results.pages || [];
      var articles = results.articles || [];
      var total = pages.length + articles.length;

      if (!total) {
        resultsEl.innerHTML =
          '<div class="kac-header__search-status">No results for &ldquo;' + escapeHtml(query) + '&rdquo;</div>';
        showResults();
        currentItems = [];
        return;
      }

      var html = '';

      html += buildGroup('Pages', pages, function (page) {
        return (
          '<a href="' + page.url + '" class="kac-header__search-result" data-kac-search-item>' +
          '<div class="kac-header__search-result-text">' +
          '<span class="kac-header__search-result-title">' + escapeHtml(page.title) + '</span>' +
          '<span class="kac-header__search-result-meta">Page</span>' +
          '</div></a>'
        );
      });

      html += buildGroup('Articles', articles, function (article) {
        return (
          '<a href="' + article.url + '" class="kac-header__search-result" data-kac-search-item>' +
          '<div class="kac-header__search-result-text">' +
          '<span class="kac-header__search-result-title">' + escapeHtml(article.title) + '</span>' +
          '<span class="kac-header__search-result-meta">Article</span>' +
          '</div></a>'
        );
      });

      html +=
        '<a href="' +
        form.getAttribute('action') +
        '?q=' +
        encodeURIComponent(query) +
        '" class="kac-header__search-viewall">View all results for &ldquo;' +
        escapeHtml(query) +
        '&rdquo;</a>';

      resultsEl.innerHTML = html;
      showResults();
      currentItems = Array.prototype.slice.call(resultsEl.querySelectorAll('[data-kac-search-item]'));
      activeIndex = -1;
    }

    function fetchResults(query) {
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url =
        baseUrl +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=page,article&resources[limit]=6';

      fetch(url, {
        signal: controller ? controller.signal : undefined,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (input.value.trim() === query) {
            renderResults(data, query);
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          hideResults();
        });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      lastQuery = query;
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        hideResults();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(query);
      }, 200);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && resultsEl.innerHTML) {
        showResults();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (resultsEl.hidden || !currentItems.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, currentItems.length - 1);
        currentItems.forEach(function (el, i) {
          el.classList.toggle('is-active', i === activeIndex);
        });
        currentItems[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, 0);
        currentItems.forEach(function (el, i) {
          el.classList.toggle('is-active', i === activeIndex);
        });
        currentItems[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (activeIndex > -1 && currentItems[activeIndex]) {
          e.preventDefault();
          window.location.href = currentItems[activeIndex].getAttribute('href');
        }
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        hideResults();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hideResults();
    });
  }

  function init() {
    document.querySelectorAll('[data-kac-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-kac-header]');
    if (header) initHeader(header);
  });
})();
